import { render } from "./NewWorkshopPopup.vue?vue&type=template&id=0fe7ec54&scoped=true"
import script from "./NewWorkshopPopup.vue?vue&type=script&lang=js"
export * from "./NewWorkshopPopup.vue?vue&type=script&lang=js"

import "./NewWorkshopPopup.vue?vue&type=style&index=0&id=0fe7ec54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe7ec54"]])

export default __exports__